import { defineComponent } from 'vue';
import LoadingWrapper from '@/presentation/components/loading-wrapper/loading-wrapper.vue';
import InactiveDashboardsOverviewCode from '@/presentation/components/inactive-dashboards-overview/inactive-dashboards-overview.code';

export default defineComponent({
	components: {
		LoadingWrapper
	},
	setup: () => {
		const code = new InactiveDashboardsOverviewCode();

		return {
			isLoading: code.isLoading,
			inactiveDashboards: code.inactiveDashboards,
			retrieveDescriptionParagraphsForDashboard: code.retrieveDescriptionParagraphsForDashboard.bind(code),
			retrieveIconUrlForDashboard: code.retrieveIconUrlForDashboard.bind(code),
			retrievePreviewUrlForDashboard: code.retrievePreviewUrlForDashboard.bind(code),
			openDashboardPreview: code.openDashboardPreview.bind(code)
		};
	}
});
